const dev = '_DEV';
const production = '';

export const env = dev;
export const emailEnv = 'TEST';
